import { Roles } from '@/constants';

export const canViewKpi = (user) => {
  return true;
};

export const canSetKpi = (user) => {
  return [Roles.Admin].includes(user?.type);
};
